<template>
  <basic-container>
    <el-form
      :model="searchForm"
      ref="searchFormRef"
      label-width="100px"
      label-suffix=":"
      v-show="searchBoxFlag"
    >
      <el-row :gutter="24">



        <el-col :span="6">
          <el-form-item label="项目名称" prop="projectId">
            <el-select
              v-model="searchForm.projectId"
              style="width: 100%"
              placeholder="项目名称"
              @change="projectIdChange"
            >
              <el-option
                v-for="item in projectIdList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>


        <el-col :span="6">
          <el-form-item label="服务项目名称" prop="name">
            <el-input
              clearable
              v-model="searchForm.name"
              placeholder="服务项目名称"
              maxlength="30"
            ></el-input>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="6">
          <el-form-item label="老人姓名" prop="name">
            <el-input
              clearable
              v-model="searchForm.name"
              placeholder="老人姓名"
              maxlength="16"
            ></el-input>
          </el-form-item>
        </el-col> -->

        <el-col :span="6">
          <el-form-item label="服务类型" prop="moduleType">
            <el-select v-model="searchForm.moduleType" style="width: 100%" placeholder="服务类型">
              <el-option
                v-for="item in moduleTypeList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="启用状态" prop="status">
            <el-select v-model="searchForm.status" style="width: 100%" placeholder="启用状态">
              <el-option
                v-for="item in statusList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="6">
          <el-form-item label="身份证号" prop="idNumber">
            <el-input
              clearable
              v-model="searchForm.idNumber"
              placeholder="身份证号"
              maxlength="16"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="政治面貌" prop="politicalFeatures">
            <el-select
              v-model="searchForm.politicalFeatures"
              style="width: 100%"
              placeholder="政治面貌"
            >
              <el-option
                v-for="item in politicalFeaturesList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col> -->

        <el-col :span="24">
          <div style="float: right">
            <el-button type="primary" icon="el-icon-search" @click="searchRecord" size="small">
              搜索
            </el-button>
            <el-button icon="el-icon-delete" @click="searchClear" size="small"> 清空 </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      ref="crud"
      @on-load="onLoad"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @selection-change="selectionChange"
    >
      <template slot="menuRight">
        <searchFromShow
          :searchBoxFlag.sync="searchBoxFlag"
          :removeHeight="searchHeight"
          :option="option"
          reduceHeight="20"
          :refOption="$refs.crud"
        ></searchFromShow>
      </template>

      <template slot="menuLeft">
        <el-button type="primary" size="small"
                   @click="addNursingForm"> 新 增</el-button>
      </template>
      <template slot-scope="scope" slot="menu">
        <el-button type="text" size="small" @click="viewFun(scope.row)">查看 </el-button>
        <el-button type="text" size="small" @click="editRecord(scope.row)">编辑 </el-button>
        <!-- <el-button type="text" size="small" v-if="permissionList.delBtn" @click="deleteFun(scope.row.id)">删除 </el-button> -->
        <el-button type="text" size="small" v-if="permissionList.statusBtn&&scope.row.status==1" @click="statusFun(scope.row.id,0)">禁用</el-button>
        <el-button type="text" size="small" v-if="permissionList.statusBtn&&scope.row.status==0" @click="statusFun(scope.row.id,1)">启用</el-button>
      </template>
    </avue-crud>

    <itemList ref="itemList"></itemList>
    <hr-dialog
      :title="formModel==='add'?'新增':formModel==='edit'?'编辑':'查看'"
      :allowFull="false"
      width="60%"

      @close="closeAddOldManDialog"
      :visible.sync="nursingFormVisible"
    >
      <template slot="body">
        <peopleForm
          :model="formModel"
          :row="formRow"
          @cancle="recordCancle"
          v-if="nursingFormVisible"
          @success="recordSuccess"
          @stepsuccess="onLoad"
          :projectId="this.searchForm.projectId"
        ></peopleForm>
      </template>
    </hr-dialog>
  </basic-container>
</template>
<script>
  import { basicInforRemove,
    getServiceProjectPage,
    stockWarnPage, getWarehouseList,
    stockWarnDelete,updateServiceProjectStatus } from '../api/serveItemManage.js';

  import { getProjectList } from '@/api/crmedical/project/project';
  import searchFromShow from '@/components/search-form-show/index';
  import peopleForm from './peopleForm.vue';
  import { getDictionary } from '@/api/common.js';
  // import { removeStore } from '@/util/store';
  import { removeStore,getStore } from '@/util/store';
  import { mapGetters } from 'vuex';
  export default {
    components: { searchFromShow, peopleForm },
    data() {
      return {
        editVisible: false,
        formModel: 'add',
        isImportDialogShow: false,
        settingTotalWarnVisible: false,
        nursingFormVisible: false,
        printVisible: false,
        addOrderVisible: false,
        alarmRuleVisible: false,
        alarmRuleTittle: '编辑',
        alarmRuleModel: 'view',
        rowInfo: {},
        searchForm: {
          name:'',
          projectId:'',
          moduleType:'',
          status:'',
          warehouseId: '',
          type: '0',
          consumableCode: '',
          consumableName: '',
          specification: '',
          upWarnFlag: 'false',
          downWarnFlag: 'false',
        },
        option: {
          selection: false,
          select: true,
          index: true,
          indexLabel: '#',
          page: true,
          height: 'auto',
          calcHeight: 'auto',
          align: 'left',
          menu: true,
          addBtn: false,
          editBtn: false,
          delBtn: false,
          border: true,
          column: [
            {
              label: '服务项目名称',
              prop: 'name',
            },
            {
              label: '副标题',
              prop: 'subtitle',
            },

            {
              label: '所属项目',
              prop: 'projectId',
              dicUrl: '/api/v4ward/project/getProjectList',
              props: {
                label: 'name',
                value: 'id',
              },
            },
            // {
            //   label: '身份证号码',
            //   prop: 'idNumber',
            // },
            {
              label: '所属服务类型',
              prop: 'moduleType',
              dicUrl: '/api/blade-system/dict/dictionary?code=out_order_module_type',
              props: {
                label: 'dictValue',
                value: 'dictKey',
              },
            },

            {
              label: '预付款',
              prop: 'dropInFee',
            },
            {
              label: '排序',
              prop: 'sort',
            },
            {
              label: '状态',
              prop: 'status',

              dicData: [
                {
                  label: '禁用',
                  value: 0,
                },
                {
                  label: '启用',
                  value: 1,
                },
              ],
            },

          ],
        },
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0,
        },
        loading: false,
        searchBoxFlag: true,
        searchHeight: '',
        selectionList: [],
        recordIds: [],
        canteenList: [],
        warehouseList: [],
        selectionIds: '',
        formRow: {},
        sexList: [],
        politicList: [],
        politicalFeaturesList: [],
        projectIdList:[],
        moduleTypeList:[],
        statusList:[{
          dictKey:'1',
          dictValue:'启用'
        },{
          dictKey:'0',
          dictValue:'禁用'
        }]
      };
    },
    created() {
      this.initData();
    },
    computed: {

      ...mapGetters(['permission']),
      permissionList() {
        return {
          viewBtn: this.vaildData(this.permission.service_project_view, false),
          addBtn: this.vaildData(this.permission.service_project_add, false),
          editBtn: this.vaildData(this.permission.service_project_edit, false),
          statusBtn: this.vaildData(this.permission.service_project_status, false),
        };
      },

    },
    mounted() {
      this.calcHeight();
      let self = this;
      self.$refs.crud.doLayout();
      window.onresize = () => {
        self.$refs.crud.doLayout();
      }
    },
    activated(){
      console.log('activated=======================');
      this.$refs.crud.doLayout();
    },
    methods: {
      statusFun(id,status){
        updateServiceProjectStatus({id:id,status:status}).then((res)=>{

          this.$message.success('操作成功');
          this.onLoad();
        });
      },
      projectIdChange(projectId){

      },
      closeAddOldManDialog(){
        removeStore({
          name:'elderId'
        });
      },
      openItemDetail(row) {
        this.$refs.itemList.openItemListOnload(row.id, row.name);
      },
      addNursingForm() {
        removeStore({
          name:'elderId'
        });
        this.formModel = 'add';
        this.formRow.projectId = this.searchForm.projectId;
        this.nursingFormVisible = true;
      },
      importSuccess() {
        this.isImportDialogShow = false;
        this.onLoad();
      },

      deleteFun(id) {
        this.$confirm(' 是否删除该数据?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            basicInforRemove(id).then((re) => {
              this.$message.success('删除成功');
              this.onLoad();
            });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消操作',
            });
          });
      },

      editRecord(row) {
        this.formModel = 'edit';
        this.formRow = row;
        this.nursingFormVisible = true;
      },
      viewFun(row){
        this.formModel = 'view';
        this.formRow = row;
        this.nursingFormVisible = true;
      },
      settingTotalWarn() {
        this.formModel = 'add';
        this.settingTotalWarnVisible = true;
      },
      importFun() {
        this.isImportDialogShow = true;
      },
      nursingForm() {
        this.formModel = 'add';
        this.nursingFormVisible = true;
      },

      recordCancle() {
        removeStore({
          name:'elderId'
        });
        this.editVisible = false;
        this.nursingFormVisible = false;
        this.settingTotalWarnVisible = false;
      },
      recordSuccess() {
        this.editVisible = false;
        this.nursingFormVisible = false;
        this.settingTotalWarnVisible = false;
        this.onLoad();
      },
      viewRecord(row) {
        this.alarmRuleTittle = '查看';
        this.rowInfo = row;

        this.alarmRuleModel = 'view';
        this.alarmRuleVisible = true;
      },

      addRecord() {
        this.alarmRuleTittle = '新增';
        this.alarmRuleVisible = true;
        this.alarmRuleModel = 'add';
      },

      stopCanteen() {
        this.alarmRuleVisible = true;
      },
      searchRecord() {
        this.page.currentPage = 1;
        if (this.searchForm.upWarnFlag == '') {
          this.searchForm.upWarnFlag = false;
        }
        if (this.searchForm.downWarnFlag == '') {
          this.searchForm.downWarnFlag = false;
        }
        this.onLoad();
      },
      searchClear() {
        this.tool.clearObject(this.searchForm, 'projectId');
        this.searchForm.type = '0';
      },

      calcHeight() {
        this.searchHeight = this.$refs.searchFormRef.$el.clientHeight;
        this.option.height = this.bodyHeight - this.searchHeight - 279 - 20;
      },
      initData() {
        getProjectList().then(res=>{
          this.projectIdList = res.data;
          this.searchForm.projectId = res.data[0].id;
          this.onLoad();
        });
        getDictionary("sex").then(res=>{
          this.sexList = res.data
        })
        getDictionary("out_order_module_type").then(res=>{
          this.moduleTypeList = res.data
        })

      },
      resetModuleType(){
        this.data.forEach(ele=>{
          ele.moduleType = ele.moduleType+'';
        });
      },
      onLoad() {
        if (this.searchForm.projectId != '') {
          this.loading = true;

          getServiceProjectPage(
            Object.assign(
              {},
              { current: this.page.currentPage, size: this.page.pageSize },
              this.searchForm
            )
          )
            .then(({ data }) => {
              this.data = data.records;
              this.page.total = data.total;
              this.resetModuleType();
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
        }
      },
    },
  };
</script>

<style scoped>
  ::v-deep .avue-crud__right {
    display: flex;
  }
  /deep/ .el-drawer__body {
    overflow: scroll !important;
  }
  ::v-deep .avue-crud .el-form-item {
    display: block;
  }

  .money {
    text-align: right;
  }
  .txtOver {
    display: -webkit-box;
    overflow: hidden; /*超出隐藏*/
    text-overflow: ellipsis; /*隐藏后添加省略号*/
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
</style>
<style>
  #alarmRule > div > div.el-dialog__body {
    height: calc(100% - 100px);
  }
</style>
